import { HttpHeader } from '@angular-cool/http';
import { IResponseInterceptor } from '@angular-cool/http/lib/response-interceptor.interface';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentications.service';
import { HttpStatusCodes } from './status-codes.enum';
import { JWT_TOKEN_EXPIRED } from '../../../../../../common/errors';

export const API_EXCEPTIONS: RegExp[] = [
  /\/api\/authentications\/password\/login$/, /\/api\/authentications\/session$/,
];

@Injectable()
export class UnauthenticatedInterceptor implements IResponseInterceptor {
  constructor(private _authenticationService: AuthenticationService) {}

  public async afterResponseAsync(
    response: any,
    url: string,
    method: string,
    data: any,
    headers: HttpHeader[],
  ): Promise<boolean> {
    let forceLogout = false;
    try {
      const { statusCode, message } = JSON.parse(response.error);
      forceLogout = message === JWT_TOKEN_EXPIRED && statusCode === 401
    } catch (e) {}

    if ((response.status === HttpStatusCodes.UNAUTHORIZED && !API_EXCEPTIONS.some((exception) => exception.test(response.url))) || forceLogout) {
      await this._authenticationService.logoutAsync();

      return true;
    }

    return false;
  }
}
